import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { CreateOpcionDto, CreatePreguntaDto, IntentoTest, Opcion, Pregunta, SubmitTestDto } from './types/cursos.types';

export class TestsService {
  static async addPregunta(paginaId: string, dto: CreatePreguntaDto): Promise<Pregunta> {
    const response: AxiosResponse<Pregunta> = await AxiosService.post(`/cursos/paginas/${paginaId}/preguntas`, dto);
    return response.data;
  }

  static async updatePregunta(id: string, dto: Partial<CreatePreguntaDto>): Promise<Pregunta> {
    const response: AxiosResponse<Pregunta> = await AxiosService.patch(`/cursos/preguntas/${id}`, dto);
    return response.data;
  }

  static async removePregunta(id: string): Promise<void> {
    await AxiosService.delete(`/cursos/preguntas/${id}`);
  }

  static async addOpcion(preguntaId: string, dto: CreateOpcionDto): Promise<Opcion> {
    const response: AxiosResponse<Opcion> = await AxiosService.post(`/cursos/preguntas/${preguntaId}/opciones`, dto);
    return response.data;
  }

  static async removeOpcion(id: string): Promise<void> {
    await AxiosService.delete(`/cursos/opciones/${id}`);
  }

  static async submitIntento(paginaId: string, dto: SubmitTestDto): Promise<IntentoTest> {
    const response: AxiosResponse<IntentoTest> = await AxiosService.post(`/cursos/paginas/${paginaId}/intentos`, dto);
    return response.data;
  }

  static async findIntentos(paginaId: string): Promise<IntentoTest[]> {
    const response: AxiosResponse<IntentoTest[]> = await AxiosService.get(`/cursos/paginas/${paginaId}/intentos`);
    return response.data;
  }
}
